import { useSignUpRouting } from '../../hooks/useSignUpRouting';
import { LoadingPage } from '../LoadingPage/LoadingPage';
/**
 * if user has been invited, accept invite and navigate to /home/projects
 * if auto-join is enabled and user's domain is claimed, auto-join the org
 * if user has not been invited, navigate to /onboarding/create-org
 * @returns {JSX.Element}
 */
export const SignUpRouter = () => {

  const { isLoading, error, user, invitedEmail, claimedDomain, myInfo } = useSignUpRouting();

  // placeholder for loading and error pages
  if (isLoading) return <LoadingPage />;
  if (error) return <div>{`Error: ${error.message}`}</div>;
  if (!user) return <div>Invalid user</div>;
  if (user && invitedEmail) return <div>Accepting invite...</div>;
  if (claimedDomain && myInfo?.builder?.id) return <div>Joining your organization...</div>;
  return <div>Onboarding...</div>;
};
